/**
 * Format a numeric amount for display in dashboard and lists.
 * Uses 2 decimal places so totals are consistent across cards (e.g. "Total facturado" and "Aceptadas este mes").
 */
export function formatDashboardCurrency(value: number): string {
  // es-UY: dot thousands, comma decimal ("10.000,00"). Passing undefined here
  // used the browser's default locale (en-US → "10,000.00") for non-UY users.
  return new Intl.NumberFormat("es-UY", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Money amount in es-UY with exactly 2 decimals, no currency symbol ("10.000,00").
 * Use for displayed totals (subtotal / tax / total) instead of `.toFixed(2)`,
 * which renders US-style "10000.00" (no thousands separator, dot decimal).
 */
export function formatMoney(value: number): string {
  return new Intl.NumberFormat("es-UY", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
